<template>
  <IndexLayout
    v-if="$route.meta.anonymousAuth && ['/'].indexOf(this.$route.path) < 0"
  ></IndexLayout>
  <!-- <v-app v-else-if="parceiroLogin">
    <core-toolbar
      :color="$theme.options.toolbar.color"
      style="box-shadow: none"
    >
      <template slot="toolbar-avatar">
        <v-avatar
          style="cursor: pointer"
          @click="gotoHome"
          max-height="50px"
          size="100"
          class="ml-3"
          tile
        >
          <v-img
            :src="logo"
            width="100%"
            height="100%"
            contain
            data-cy="toolbar-img"
          />
        </v-avatar>
      </template>

      <template slot="toolbar-title"> &nbsp; </template>
      <template slot="toolbar-drawer"> &nbsp; </template>

      <template slot="toolbar-after-spacer">
        <div class="ml-auto mr-0" v-if="portalBloqueado">
          <v-tooltip bottom max-width="300">
            <template v-slot:activator="{ on }">
              <v-chip color="warning" v-on="on">
                <v-icon small class="mr-2">ph-warning</v-icon>
                Portal Bloqueado
              </v-chip>
            </template>
            <span data-cy="tooltip-text"
              >Não é possível realizar inclusões e alterações de dados!</span
            >
          </v-tooltip>
        </div>
      </template>
    </core-toolbar>

    <v-main>
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <router-view></router-view>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <slot name="footer">
      <v-footer inset app :color="$theme.options.footer.color">
        <v-row class="justify-center textFooter--text">
          <span class="px-4"
            >&copy; {{ new Date().getFullYear() }} - {{ nome }}</span
          >
        </v-row>
      </v-footer>
    </slot>
  </v-app> -->
  <v-app v-else>
    <v-main>
      <v-container
        id="layout-main-container"
        fluid
        style="height: 100%;"
        class="pa-0 ma-0"
      >
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<style lang="sass">
@import 'assets/styles/styles.scss'

$white-color: #FFF
$blue-color: #201f49

.layout-main-container
  &-white
    background-color: $white-color

  &-blue
    background-color: $blue-color
</style>

<script>
export default {
  components: {
    IndexLayout: () => import('@bmp-vue/core/layouts/IndexLayout'),
  },
  data () {
    return {
      parceiroLogin: false,
      ambiente: localStorage.ambiente,
      nome: window.env.VUE_APP_NOME,
    }
  },
  methods: {
    gotoHome () {
      this.$router.goToHome(this.$route.path)
    },
  },
  computed: {
    portalBloqueado () {
      return JSON.parse(localStorage.empresa).portalIndicadorBloqueio
    },
  },
  beforeMount () {
    this.logo = this.$theme.options.logoHeaderHome
  },
  mounted () {
    if (localStorage.parceiroLogin) {
      this.parceiroLogin = true
    }
  },
  created () {
    const vm = this
    if (localStorage.status === 'loggedIn' && location.pathname) {
      const regexCorrentista = /\/?authToken\/?/gm
      if (
        regexCorrentista.test(location.pathname) &&
        location.search.indexOf('?token=') >= 0
      ) {
        vm.$api.UTIL.Auth.Logout()
      }

      const regexParceiro = /\/?authPartnerToken\/?/gm
      if (
        regexParceiro.test(location.pathname)
      ) {
        vm.$api.UTIL.Auth.Logout()
      }
    }
  },
}
</script>
